import React, { useEffect, useState } from 'react'
import HomeNav from '../Navbars/HomeNav'
import config from '../../function/config';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Usernav from '../UserHome/Usernav';
import AdminNav from '../Admin/AdminHome/AdminNav';
import NewAdminNav from '../Admin/AdminHome/NewAdminNav';
import NewHomeNav from '../Navbars/NewHomeNav';
export default function MainEngine() {
const [user,setUser] = useState(null)
    const token = localStorage.getItem('token')
     const navigate = useNavigate('')
    useEffect(() => {
        async function fetchdata() {
          try {
            const res2 = await axios.get(
              `${config.base_url}/api/HappyMarineShipping/viewusers`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Token ${token}`,
                },
              }
            );
            console.log("API response:", res2.data);
            if (res2.data.status === 200) {
              console.log("User:",res2);
              setUser(res2.data.data);
            } else {
              console.log(res2);
            }
          } catch (error) {
            console.log(error);
          }
        }
        fetchdata();
      }, [ token]);

      
  return (
    <div>
         {user ? (user.is_superuser ? <NewAdminNav /> :  <Usernav />) : <NewHomeNav/>}
      <div className=' bg-[#9ccee2] h-[100vh]' >
        <h1 className='text-center py-10 text-white text-2xl font-bold'>Main Engine </h1>
        </div >
    </div>
  )
}
